import React from "react";
import { FiTwitter, FiYoutube } from "react-icons/fi";
import { TbBrandDiscord } from "react-icons/tb";

function SocialRow() {
  return (
    <div className="w-full flex flex-row items-center justify-center gap-8">
      <a
        href="https://twitter.com/CollatsToken"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FiTwitter size={24} />
      </a>
      <a
        href="https://discord.gg/hbM5bkyBaa"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TbBrandDiscord size={24} />
      </a>
      <a
        href="https://www.youtube.com/channel/UC2ozI3w9F1Kl2iRaxNB6Wjw/featured"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FiYoutube size={24} />
      </a>
    </div>
  );
}

export default SocialRow;
